export class ReportAgingFilterModel {
  ProvidersId: string[];
  PracticeId: number;
  PracticeLocations: string[];
  IsTrueBalance: boolean;
  isProvider: boolean;
  isPractice: boolean;
  IsAllPeriods: boolean;
  isCurrent: boolean;
  is30Day: boolean;
  is60Day: boolean;
  is90Day: boolean;
}



